// Navbar.jsx
import React, { useState, useEffect } from "react";
import { FaBars, FaTimes } from "react-icons/fa";
import { Link, useLocation } from "react-router-dom";
import logo from "../assets/white-1.svg";

function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
  }, [mobileMenuOpen]);

  const navLinks = [
    { name: "Home", href: "/" },
    { name: "Services", href: "/services" },
    { name: "Portfolio", href: "/portfolio" },
    { name: "Careers", href: "/careers" },
    { name: "About Us", href: "/about" },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black py-3 shadow-lg border-b border-white/10" // Scrolled state (Solid Black)
          : "bg-black py-4" // Initial state (Solid Black - Removed opacity/blur)
      }`}
    >
      <div className="mx-auto max-w-7xl px-6">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link to="/">
            <div className="cursor-pointer transition-transform hover:scale-105">
              <img className="w-48 md:w-56" src={logo} alt="Nexonetics" />
            </div>
          </Link>

          {/* Desktop Menu - Centered */}
          <div className="hidden md:flex items-center justify-center flex-1 gap-12">
            {navLinks.map((link, index) => (
              <Link key={index} to={link.href}>
                <div
                  className={`text-sm font-medium transition-colors hover:-translate-y-0.5 transform duration-200 ${
                    location.pathname === link.href
                      ? "text-cyan-400"
                      : "text-white/80 hover:text-white"
                  }`}
                >
                  {link.name}
                </div>
              </Link>
            ))}
          </div>

          {/* Contact Button (Desktop) */}
          <Link to="/contact">
            <button className="hidden md:block rounded-full border border-white/20 bg-white/10 px-6 py-2 text-sm font-medium text-white backdrop-blur-sm transition-all hover:bg-white hover:text-black hover:scale-105 active:scale-95">
              Contact Us
            </button>
          </Link>

          {/* Mobile Menu Toggle (Hamburger) */}
          <button
            onClick={() => setMobileMenuOpen(true)}
            className="md:hidden text-white text-2xl z-50"
          >
            <FaBars />
          </button>
        </div>
      </div>

      {/* Full Screen Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-[60] flex flex-col bg-black md:hidden">
          {/* Mobile Header with Logo and Close Button */}
          <div className="flex items-center justify-between p-6 border-b border-white/10">
            <img className="w-40" src={logo} alt="Logo" />
            <button
              onClick={() => setMobileMenuOpen(false)}
              className="text-white text-3xl hover:text-cyan-400 transition-colors"
            >
              <FaTimes />
            </button>
          </div>

          {/* Mobile Links Container */}
          <div className="flex flex-col items-center justify-center flex-1 gap-8">
            {navLinks.map((link, index) => (
              <Link
                key={index}
                to={link.href}
                onClick={() => setMobileMenuOpen(false)}
              >
                <div
                  className={`text-2xl font-medium ${
                    location.pathname === link.href
                      ? "text-cyan-400"
                      : "text-white/80 hover:text-white"
                  }`}
                >
                  {link.name}
                </div>
              </Link>
            ))}

            <Link to="/contact" onClick={() => setMobileMenuOpen(false)}>
              <button className="mt-4 rounded-full border border-white/20 bg-white/10 px-8 py-3 text-lg font-medium text-white backdrop-blur-sm transition-all hover:bg-white hover:text-black">
                Contact Us
              </button>
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}

export default Navbar;
